import React, { useContext, useEffect } from 'react';
import { Checkbox } from '@material-ui/core';
import { TableStateContext } from '../../../../contexts/tableState/TableStateContext';

function HeaderCheckbox({ idList, tableName }: { tableName: string; idList: string[] }) {
  const { state, setAllRowsIsChecked } = useContext(TableStateContext);

  return (
    <Checkbox
      checked={state[tableName]?.checkedIds?.length === idList.length}
      onChange={() => setAllRowsIsChecked(tableName, idList)}
      style={{
        padding: 0,
        marginLeft: 9,
      }}
    />
  );
}

export default HeaderCheckbox;
